import { AreaVisitsIcon } from 'src/components/insights/icons/area-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/area-visits-nearby-foot-traffic-trends.png'

const NearbyLocationsCard = dynamic(() => import('src/components/insights/area-visits/nearby-locations'), {
  ssr: false,
})

export const NearbyLocationsWidget: InsightBuilderWidget = {
  id: 'area-visits-nearby-locations',
  name: 'Nearby Locations Visitation',
  type: 'Area Visits',
  icon: AreaVisitsIcon,
  component: NearbyLocationsCard,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
